'use client';

import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <section className="container-body flex min-h-[70vh] flex-col items-center justify-center gap-6 py-24 text-center">
      <div className="type-hero text-[var(--color-danger)]">Φ</div>
      <h1 className="type-h2">Algo se interrumpió.</h1>
      <p className="type-body-lg max-w-xl text-[var(--color-fg-muted)]">
        Hemos registrado el problema y lo estamos observando. Puedes intentar de nuevo o volver al inicio.
      </p>
      {error.digest ? (
        <code className="type-caption text-[var(--color-fg-subtle)]">ref: {error.digest}</code>
      ) : null}
      <div className="flex gap-3">
        <button
          onClick={reset}
          className="type-nav rounded-sm bg-[var(--color-accent)] px-6 py-3 text-[var(--color-accent-fg)]"
        >
          Reintentar
        </button>
        <a
          href="/"
          className="type-nav rounded-sm border border-[var(--color-border-strong)] px-6 py-3 text-[var(--color-fg)]"
        >
          Ir al inicio
        </a>
      </div>
    </section>
  );
}
